var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper"}},[(_vm.isAuth)?_c('Sidebar'):_vm._e(),_c('div',{staticClass:"d-flex flex-column",attrs:{"id":"content-wrapper"}},[_c('div',{attrs:{"id":"content"}},[(_vm.isAuth)?_c('Navbar'):_vm._e(),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1),(_vm.isAuth)?_c('Footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }